/* eslint-disable unicorn/filename-case -- is a utility function which returns a ReactNode */
import { type WithErrorBoundaryOptions, withErrorBoundary as withErrorBoundaryRc } from '@pba/react-components';
import type { ComponentType } from 'react';
import { ErrorDebugResult } from '../error-debug-result';

const withErrorBoundary = <TProperties extends object>(
  Component: ComponentType<TProperties>,
  options: Omit<WithErrorBoundaryOptions, 'ErrorDebugResult'> = {},
) => withErrorBoundaryRc(Component, { ...options, ErrorDebugResult });

export default withErrorBoundary;
/* eslint-enable unicorn/filename-case -- is a utility function which returns a ReactNode */
